import { IonBreadcrumb } from '@ionic/react';
import styled from 'styled-components';

export const StyledBreadcrumb: any = styled(IonBreadcrumb)<{ selected?: boolean }>`
  --color: var(--allie-color-neutral-60);
  --color-active: var(--allie-color-neutral-60);
  --color-hover: var(--allie-color-neutral-90);
  cursor: pointer;

  ${({ selected }) => selected && `
    --color: var(--allie-color-neutral-90);
    --color-active: var(--allie-color-neutral-90);
    --color-hover: var(--allie-color-neutral-90);
    &&{font-weight: 600};
  `}
`;
